import React, { useState, useEffect, useCallback } from "react";
import { Container, Box } from "@material-ui/core";
import {
  Typography,
  AppBar,
  Toolbar,
  Link,
  CardActionArea,
  TextField,
  Button,
  Paper,
  FormControlLabel,
  Checkbox,
  CircularProgress,
} from "@material-ui/core";
import {
  Grid,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  LinearProgress,
  Chip,
  Avatar,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Badge
} from "@material-ui/core";
import {
  DesktopMac,
  Add,
  FilterList,
  Group,
  ArrowForwardIos,
  Block,
  CheckCircle,
  Close,
  Assignment,
  Refresh,
  CallSplit,
} from "@material-ui/icons";
import { withLocalize, Translate } from "react-localize-redux";
import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/styles";

import MUIDataTable from "mui-datatables";

import { Skeleton } from "@material-ui/lab";

import { useSnackbar } from "notistack";

import {
  FinanceService,
  AdminService,
} from "../../../../../../utils/web_config";
import { useTransactionTypes } from "../../../../hooks/use_hooks";

const axios = require("axios");

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 250,
    },
  },
  title: {
    flexGrow: 1,
  },
  btn: {
    textTransform: "capitalize",
  },
  btn2: {
    textTransform: "capitalize",
    border: "dashed grey 1px",
  },
  paper: {
    padding: 15,
  },
  action: {
    borderRadius: 15,
  },
}));

function Batches(props) {
  const classes = useStyles();
  const history = useHistory();

  // format money 
  function formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

      const negativeSign = amount < 0 ? "-" : "";

      let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
      let j = (i.length > 3) ? i.length % 3 : 0;

      return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
      console.log(e)
    }
  };

  const [accountData, setAccountData] = useState({});

  const [batches, setBatchess] = useState({
    page: 0,
    count: 1,
    rowsPerPage: 10,
    sortOrder: {},
    status: "Loading settlement batches....",
    loading: false,
    toggling: false,
    data: [],
  });

  const [transfers, setTransfers] = useState({
    page: 0,
    count: 1,
    rowsPerPage: 10,
    sortOrder: {},
    status: "Loading settlement transfers...",
    loading: false,
    toggling: false,
    open: false,
    data: [],
  });

  const [resending, setResending] = useState({ loading: false });
  const [initiating,setInitiating]=useState({open:false,loading:false})

  const [commissionData,setCommissionData]=useState([])
  const [commissionDataDialog,setCommissionDataDialog]=useState(false)


  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    var accountData = new AdminService().accountData;
    setAccountData(accountData);
    getBatchess(accountData.token, history.location.state.process_reference);
  }, []);

  const capitalize = (s) => {
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
  };
  /////////////////////
  const notify = (variant, msg, status) => {
    if (status == 401) {
      history.push("/", { expired: true });
    }
    enqueueSnackbar(msg, {
      variant: variant,
      action: (k) => (
        <IconButton
          onClick={() => {
            closeSnackbar(k);
          }}
          size="small"
        >
          <Close fontSize="small" />
        </IconButton>
      ),
    });
  };
  //////////
  const batchesColums = [
    {
      name: "account_name",
      label: "Account name",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "account_number",
      label: "Account number",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "batch_number",
      label: "Batch number",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: function (dataI, rowI) {
          return (<Typography style={{ color: "red" }}><Link onClick={() => {
            getTransfers(batches.data[dataI].batch_number);
          }} href="#">{batches.data[dataI].batch_number}</Link>

          </Typography>)
        },
      },
    },
    {
      name: "total_number",
      label: "Total trans",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "total_amount",
      label: "Total amount",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "commission_amount",
      label: "Commission",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: function (dataI, rowI) {
          return (<Typography style={{ color: "red" }}><Link onClick={() => {
            setCommissionData(batches.data[dataI].commission_data);
            setCommissionDataDialog(true);

          }} href="#">{batches.data[dataI].commission_amount}</Link>

          </Typography>)
        },
      },
    },

    {
      name: "operator_amount",
      label: "Operator amount",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "settlement_status",
      label: "Settlement status",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: function (dataI, rowI) {
          return (
            <Chip
              avatar={
                <Avatar>
                  {["collected", "settled"].includes(
                    batches.data[dataI].settlement_status.toLowerCase()
                  ) ? (
                    <CheckCircle fontSize="small" />
                  ) : (
                    <Block fontSize="small" />
                  )}
                </Avatar>
              }
              variant="outlined"
              color={
                batches.data[dataI].settlement_status.toLowerCase() == "settled"
                  ? "primary"
                  : "default"
              }
              size="small"
              label={capitalize(batches.data[dataI].settlement_status)}
            />
          );
        },
      },
    },

    {
      name: "transfer_status",
      label: "Transfer status",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: function (dataI, rowI) {
          return (
            <Chip
              avatar={
                <Avatar>
                  {batches.data[dataI].transfer_status.toLowerCase() ==
                  "completed" ? (
                    <CheckCircle fontSize="small" />
                  ) : (
                    <Block fontSize="small" />
                  )}
                </Avatar>
              }
              variant="outlined"
              color={
                batches.data[dataI].transfer_status.toLowerCase() == "completed"
                  ? "primary"
                  : "default"
              }
              size="small"
              label={capitalize(batches.data[dataI].transfer_status)}
            />
          );
        },
      },
    },
  ];

  //////////
  const transfersColums = [
    {
      name: "transfer_reference",
      label: "Reference",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "tx_type",
      label: "Transaction",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "debited_bank_account",
      label: "Debited account",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "credited_bank_account",
      label: "Creadited account",
      options: {
        filter: true,
        sort: false,
      },
    },

    {
      name: "amount",
      label: "Amount",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "created_at",
      label: "Transfer date",
      options: {
        filter: false,
        sort: false,
      },
    },

    {
      name: "transfer_status",
      label: "Status",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: function (dataI, rowI) {
          return (
            <Chip
              avatar={
                <Avatar>
                  {transfers.data[dataI].transfer_status.toLowerCase() ==
                  "completed" ? (
                    <CheckCircle fontSize="small" />
                  ) : (
                    <Block fontSize="small" />
                  )}
                </Avatar>
              }
              variant="outlined"
              color={
                transfers.data[dataI].transfer_status.toLowerCase() ==
                "completed"
                  ? "primary"
                  : "default"
              }
              size="small"
              label={capitalize(transfers.data[dataI].transfer_status)}
            />
          );
        },
      },
    },
  ];

  const batchesOptions = {
    filterType: "multiselect",
    elevation: 0,
    selectableRows: "none",
    searchPlaceholder: "Search batches...",
    selectableRowsOnClick: false,
    fixedHeader: true,
    // onCellClick: (cellData, cellMeta) => {
    //   var bat = batches.data[cellMeta.dataIndex];
    //   getTransfers(bat.batch_number);

    // },
    searchProps: {
      variant: "outlined",
      margin: "dense",
    },
    textLabels: {
      body: {
        noMatch: batches.status,
      },
    },
  };

  const transfersOptions = {
    filterType: "multiselect",
    elevation: 0,
    selectableRows: "none",
    searchPlaceholder: "Search transfers",
    selectableRowsOnClick: true,
    fixedHeader: true,
    searchProps: {
      variant: "outlined",
      margin: "dense",
    },
    textLabels: {
      body: {
        noMatch: transfers.status,
      },
    },
  };

  ///////////////////////////////////

  const getBatchess = (token, ref) => {
    const usersInstance = axios.create(new AdminService().getHeaders(token));

    setBatchess({ ...batches, loading: true });

    console.log("getting batches .....");

    usersInstance
      .get(
        new FinanceService().GET_SETTLEMENT_BATCHES +
          "?per_page=10000&process_reference=" +
          ref
      )
      .then(function (response) {
        setBatchess({ ...batches, loading: false });

        const d = response.data;

        if (d.data.length == 0) {
          setBatchess({
            ...batches,
            status: "There are no settlement batches available",
          });
        } else {
          setBatchess({ ...batches, data: d.data, allData: d.data });
        }
      })
      .catch(function (error) {
        setBatchess({ ...batches, loading: false });

        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        setBatchess({ ...batches, status: e });

        notify(
          error?.response?.status == 404 ? "info" : "error",
          e,
          error?.response?.status
        );
      });
  };

  ///////////////////////////////////

  const getTransfers = (number) => {
    const usersInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );

    setTransfers({ ...transfers, loading: true, open: true });

    console.log("getting transfers.....");

    usersInstance
      .get(
        new FinanceService().GET_SETTLEMENT_TRANSFERS +
          "?per_page=10000&batch_number=" +
          number
      )
      .then(function (response) {
        setTransfers({ ...transfers, loading: false, open: true });

        const d = response.data;

        if (d.data.length == 0) {
          setTransfers({
            ...transfers,
            status: "There are no settlement transfers available",
          });
        } else {
          setTransfers({
            ...transfers,
            data: d.data,
            allData: d.data,
            open: true,
          });
        }
      })
      .catch(function (error) {
        setTransfers({ ...transfers, loading: false, open: true });

        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        setTransfers({ ...transfers, status: e, open: true });

        notify(
          error?.response?.status == 404 ? "info" : "error",
          e,
          error?.response?.status
        );
      });
  };

  //////////////////////////

      //////////////////////////////////

      const checkProcess= () => {
        const createInstance = axios.create(
          new AdminService().getHeaders(accountData.token)
        );
    
        setInitiating({...initiating,loading:true});
 
        const data = {
          "process_reference":history.location.state.process_reference
        }
        createInstance
          .get(new FinanceService().CHECK_SETTLEMENT_PROCESS+
          "?process_reference=" +
          history.location.state.process_reference,data)
          .then(function (response) {
            setInitiating({open:false,loading:false});
            var d = response.data;
    
            notify("success", d.message);
  
          })
          .catch(function (error) {
            setInitiating({open:false,loading:false});
            var e = error.message;
    
            if (error.response) {
              e = error.response.data.message;
            }
    
            notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
          });
      };


            //////////////////////////////////

            const resendTransfers= () => {
              const createInstance = axios.create(
                new AdminService().getHeaders(accountData.token)
              );
          
              setResending({...resending,loading:true});
       
              const data = {
                "process_reference":history.location.state.process_reference
              }
              createInstance
                .put(new FinanceService().RESEND_SETTLEMENT_TRANSFERS,data)
                .then(function (response) {
                  setResending({...resending,loading:false});
                  var d = response.data;
          
                  getTransfers()
                  notify("success", d.message);
        
                })
                .catch(function (error) {
                  setResending({...resending,loading:false});
                  var e = error.message;
          
                  if (error.response) {
                    e = error.response.data.message;
                  }
          
                  notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
                });
            };
    

  return (
    <div className={classes.root}>



      {/* validators  */}



      <Dialog
        maxWidth="sm"
        fullWidth
        open={commissionDataDialog}
        onClose={() => {
          setCommissionDataDialog(false);
        }}
        aria-labelledby="Validator"
        aria-describedby="Validator"
      >
        <DialogTitle id="Validator">{"Commission Data"}</DialogTitle>
        <DialogContent>
          <DialogContentText >
            <Box>
              <List component="nav" aria-label="main mailbox folders">
                {commissionData.map((o) => {
                  return (
                    <ListItem >
                      <ListItemText primary={<b>{o['name']}</b>} secondary={formatMoney(o['commission_total_amount']) + " RWF"} />
                      <ListItemSecondaryAction>
                        {/* <Badge
                          badgeContent={o['computation_mode']}
                          variant="standard"
                          color="secondary"
                        /> */}
                      </ListItemSecondaryAction>
                    </ListItem>
                  );
                })}
              </List>
            </Box>
          </DialogContentText>
        </DialogContent>

        <DialogActions>

          <Button onClick={() => {
            setCommissionDataDialog(false);
          }} color="secondary" className={classes.btn}>
            <Typography>Close</Typography>
          </Button>





        </DialogActions>
      </Dialog>



      {/* Dialogs starts here */}

      <Dialog
        open={transfers.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        onClose={() => setTransfers({ ...transfers, open: false })}
        maxWidth="lg"
      >
        <DialogTitle id="alert-dialog-title">
          <Box display="flex" justifyContent="space-between">
            {"Settlement transfers"}

            <Button
              className={classes.btn}
              variant="outlined"
              size="medium"
              color="primary"
              startIcon={
                resending.loading ? <CircularProgress size={23} /> : <Refresh />
              }
              disableElevation
              disabled={resending.loading}
              onClick={() => resendTransfers()}
            >
              {resending.loading ? "Resending..." : "Resend transfers"}
            </Button>
          </Box>
        </DialogTitle>
        <DialogContent>
          {transfers.loading && <LinearProgress />}
          <MUIDataTable
            title={"List of settlement transfers"}
            data={transfers.data}
            columns={transfersColums}
            options={transfersOptions}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setTransfers({ ...transfers, open: false });
            }}
            color="primary"
            variant="outlined"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      {/* Dialogs ends here */}

      <Box display="flex" alignItems="center">
        <Box flexGrow={1} display="flex" alignItems="center">
          <Box mr={2}>
            {" "}
            <Group color="primary" fontSize="large" />
          </Box>
          <Box flexGrow={1} display="flex" alignItems="center">
            <Typography variant="h5">
              <b>Accounts</b>
            </Typography>
            <Box ml={1} mr={1} mt={1}>
              <ArrowForwardIos fontSize="small" />
            </Box>
            <Typography variant="h6">Settlements</Typography>

            <Box ml={1} mr={1} mt={1}>
              <ArrowForwardIos fontSize="small" />
            </Box>
            <Typography variant="h6">Batches</Typography>
          </Box>
        </Box>

        <Button
          className={classes.btn}
          variant="contained"
          size="medium"
          color='primary'
          startIcon={initiating.loading?<CircularProgress size={23}/>:<Refresh />}
          disableElevation
          disabled={initiating.loading}
          onClick={() => checkProcess()}
        >
         {initiating.loading?'Checking...':'Recheck process'}

        </Button>
        <Box width={12} />
        <Button
          className={classes.btn}
          variant="outlined"
          size="medium"
          color="primary"
          startIcon={resending.loading? <CircularProgress size={23} /> : <CallSplit />}
          disableElevation
          onClick={() => resendTransfers()}
        >
          Resend Transfers
        </Button>
      
        {/* <Button
          className={classes.btn}
          variant="outlined"
          size="medium"
          color="primary"
          startIcon={<Assignment />}
          disableElevation
          // onClick={() => setTypesOpen(true)}
        >
          Transactions
        </Button> */}
      </Box>
      <Box mt={3} />

      {batches.loading && <LinearProgress />}
      <MUIDataTable
        title={"List of settlement batches"}
        data={batches.data}
        columns={batchesColums}
        options={batchesOptions}
      />
    </div>
  );
}

export default withLocalize(Batches);
